/**
 * Returns an 8-digit PGA ID when the search query is solely that ID
 * (digits only, or with spaces/hyphens). Otherwise null.
 */
export function parsePgaIdQuery(query: string): string | null {
  const trimmed = query.trim();
  if (!trimmed) return null;
  if (!/^[\d\s-]+$/.test(trimmed)) return null;

  const digits = trimmed.replace(/[\s-]/g, "");
  return /^\d{8}$/.test(digits) ? digits : null;
}
